<template>
  <b-form-group
    class="mb-4"
    :label="label | translate('global')">
    <b-form-textarea
      v-if="type === 'textarea'"
      v-on:input="updateValue($event)"
      :value="value"
      :required="isRequired"
      :placeholder="placeholder"
      :state="error ? false : null"></b-form-textarea>
    <div v-else-if="type === 'editor'" :class="error ? 'is-invalid' : null">
      <Editor
      v-on:input="updateValue($event)"
      :init="fieldOptions"
      :value="value"/>
    </div>

    <b-form-input
      v-else
      v-on:input="updateValue($event)"
      :value="value"
      :type="type"
      :required="isRequired"
      :placeholder="placeholder"
      :state="error ? false : null"></b-form-input>
    <b-form-invalid-feedback v-if="error">
        {{ getErrorMessage() }}
    </b-form-invalid-feedback>  
    <div class="var-desc mt-2 ml-2" v-if="variables && variables.length">
      <p class="mb-1"><strong>{{ $t('available_variables') }}:</strong></p>
      <p class="mb-0">
        <span v-b-tooltip.hover
              :title="variable.description"
              v-for="variable in variables"
              class="badge badge-primary p-2 mx-1">{{ variable.name }}</span>
      </p>
    </div>
  </b-form-group>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';

export default {
  components: { Editor },
  props: {
    label: {
      default: '',
      type: String
    },
    placeholder: {
      default: '',
      type: String
    },
    value: {
      default: null
    },
    type: {
      default: 'text',
      type: String
    },
    isRequired: {
      default: false,
      type: Boolean
    },
    variables: {
      required: false
    },
    options: {
      required: false
    },
    error: {
      default: false
    },
  },
  data() {
    return {
      fieldOptions: {}
    }
  },
  watch: {
    data: {
      handler() {
        if (this.options) {
          this.fieldOptions = this.options;
        }
      },
      immediate: true
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value);
    },
    getErrorMessage() {
      if (this.error.constructor === Array) {
        return this.error.join(' ');
      }

      return this.error;
    }
  },
}
</script>

<style>
  .tox.tox-silver-sink.tox-tinymce-aux .tox-notification { display: none !important }
</style>
